export default __webpack_public_path__ + "static/media/Archpriest's Gloves of the Nine Springs.b0fb5d4a.jpg";